import { Route, Routes } from "react-router-dom";
import { map } from "lodash";
import { routesBase } from "@/routes";
import { ErrorBoundary, PageNotFoundScreen } from "@/pages";

export const Application = () => {
  return (
    <Routes>
      {map(routesBase, (route, index) => (
        <Route
          key={index}
          path={route.path}
          element={route.element}
          errorElement={<ErrorBoundary />}
        />
      ))}
      <Route path="/*" element={<PageNotFoundScreen />} />
    </Routes>
  );
};
